import React from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";

export default function AppShell() {
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Outlet />
    </Box>
  );
}
